import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 315px;
  text-align: center;

  img {
    width: 252px;
    height: 55px;
  }
  form {
    display: flex;
    flex-direction: column;
    margin-top: 30px;

    div {
      height: 50px;
      background: var(--white);
      border-radius: 10px;
      margin-bottom: 8px;

      display: flex;
      flex-direction: row-reverse;
    }

    .login > div {
      margin-top: 26px;
      margin-bottom: 6px;
    }

    h1 {
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      text-align: center;
      margin-bottom: 26px;

      color: #4d4a48;
    }
    span {
      color: #d54f5b;
      align-self: flex-start;
      margin: 0 0 10px;
      font-weight: bold;
    }
    .Voltar {
      text-align: center;
      align-self: center;
      margin-top: 10px;
      background-color: transparent;
    }
    .entrar {
      height: 50px;
      margin-top: -30px;

      background: var(--purple);
      border-radius: 10px;
      transition: all 0.2s;

      &:hover {
        background: #dc5129;
      }
    }
    a {
      color: #4d4a48;
      margin-top: 15px;
      font-size: 16px;
      opacity: 0.8;
      transition: all 0.2s;

      &:hover {
        opacity: 1;
      }
    }
  }
`;

export const Forgot = styled.div`
  button {
    height: 30px;
    margin-top: -20px;
    color: var(--title-higlight);
    background: transparent;
  }
`;

export const Register = styled.div`
  p {
    margin-top: 2rem;
  }
  strong {
    color: #000000;
    padding-right: 5px;
  }
`;

export const Company = styled.div`
  p {
    margin-top: 2rem;
  }
  strong {
    color: #000000;
    padding-right: 5px;
  }
  span {
    color: #000000;
  }
  button {
    background: transparent;
    color: #000000;
  }
`;

export const DialogContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 650px;
  padding: 0;

  .container {
    text-align: center;
    width: 90%;
    height: 470px;
    margin-left: 25px;

    h3 {
      margin-bottom: 20px;
    }

    .information {
      margin-bottom: 30px;
      text-align: justify;
      margin-left: 30px;
      width: 90%;
    }
    .acessar {
      width: 90%;
      background-color: var(--orange);
      margin-bottom: 30px;
      @media (max-width: 420px) {
        margin-left: 30px;
        width: 90%;
      }
    }
  }
`;

export const Logo = styled.div`
  border-radius: 10px;
  height: 100px;
  width: 315px;
  background-color: var(--purple);

  img {
    width: 300px;
    height: 100px;
  }
`;

export const Header = styled.div`
  width: 100%;
  height: 80px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--purple);
  color: var(--purple);
`;

export const Dialogo = styled.div`
  position: relative;
  left: 25%;
  top: 13%;
  display: flex;
  background: white;
  justify-content: center;
  width: 50%;
  border-radius: 25px;
  @media (max-width: 900px) {
    left: 10%;
    width: 80%;
  }

  .container {
    text-align: center;
    width: 90%;
    height: 550px;
    @media (max-width: 420px) {
      margin-left: 0px;
      width: 100%;
    }
    h1 {
      text-align: left;
      font-size: 1.7rem;
      color: var(--orange);
      margin-top: 3rem;
      margin-bottom: 3rem;
    }
    .password {
      text-align: left;
      margin-top: 4.5rem;
    }
    .text {
      padding: 40px;
      width: 100%;
      @media (max-width: 350px) {
        padding: 40px 10px 10px 10px;
      }
    }
    p {
      font-size: 1.2rem;
      color: var(--title-higlight);
      margin-bottom: 2.5rem;
      text-align: left;
    }
    .login {
      display: block;
    }
    .buttons {
      display: flex;
    }
    .enviar {
      width: 250px;
      margin-top: 2rem;
      margin-right: 3px;
      float: right;
      @media (max-width: 740px) {
        width: 100%;
        padding: 0px;
      }
    }
  }
`;

export const Modal = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0%;
  left: 0%;
  display: none;
`;

export const Close = styled.div`
  color: var(--title-higlight);
  width: 30px;
  height: 30px;
  margin-right: 2px;
  margin-top: 20px;
  float: right;
  cursor: pointer;
`;
